import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { useDispatch } from 'react-redux';
import { Avatar, useMediaQuery } from '@material-ui/core';
import { isEmpty } from 'lodash';

import { openModal } from 'features/utilsSlice';
import { getRequest } from 'utils/api';
import { truncateText } from 'utils/helpers';
import useIsInfluencer from 'hooks/useIsInfluencer';
import NoAvatarImage from 'public/images/no-avatar.svg';
import FollowGig from 'components/FollowGig';
import styles from 'styles/components/Discover.module.scss';

const avatarFullSize = { width: '100%', height: '100%' };

const MatchGigCard = ({ gig, updateGig }) => {
  const [gigWithMilestones, setGigWithMilestones] = useState({});
  const isInfluencer = useIsInfluencer();
  const dispatch = useDispatch();

  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

  useEffect(() => {
    let isMounted = true;

    getRequest({
      endpoint: `gigs/${gig.id}`,
      query: { with_milestones: true },
    }).then(gig => {
      if (!isMounted) return;
      setGigWithMilestones(gig);
    });

    return () => (isMounted = false);
  }, [gig.id]);

  const getMilestoneTitle = () => {
    if (isEmpty(gigWithMilestones)) return;

    const milestones = gigWithMilestones.milestones;

    const networkName = milestones[0].network.name;
    const spaceName = milestones[0].inventory_space.name;
    const networkIconUrl = milestones[0].network.active_icon_url;
    const milestonesLeft = milestones.length - 1 === 0 ? '' : milestones.length - 1;

    // Truncate space name if it's too long and there are milestones left because of the chip
    const truncatedSpaceName = truncateText(spaceName, 18);

    return (
      <div className={styles.footer}>
        <div className={styles.spaceInfo}>
          <Image src={networkIconUrl} width={15} height={15} alt={networkName} unoptimized />

          <div
            className={styles.spaceName}
            style={{ width: milestonesLeft && isMobile ? 'calc(100% - 40px)' : '100%' }}
          >
            {milestonesLeft ? truncatedSpaceName : spaceName}
          </div>
        </div>

        {milestonesLeft && <div className={styles.chip}>+ {milestonesLeft}</div>}
      </div>
    );
  };

  return (
    <div
      className={styles.card}
      key={gig.id}
      onClick={() => dispatch(openModal({ name: 'Public Gig', data: { gigId: gig.id } }))}
    >
      <div className={styles.imgContainer}>
        <div className={styles.name}>
          <Avatar className={styles.avatar} src={gig.user.avatar_url}>
            <NoAvatarImage style={avatarFullSize} />
          </Avatar>

          <h6>{gig.user.display_name}</h6>
        </div>

        {isInfluencer && <FollowGig gig={gig} updateGig={updateGig} circleHeart />}

        <Image
          layout="fill"
          src={gig.thumbnail_url || '/icons/no-avatar-full.svg'}
          alt="Thumbnail"
          unoptimized
        />
      </div>

      {getMilestoneTitle()}
    </div>
  );
};

export default MatchGigCard;
